import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LoggerService } from 'src/services/logger-services/logger.service';

@Pipe({
  name: 'replaceDoubleStar'
})
export class ReplaceDoubleStarPipe implements PipeTransform {
  private readonly ReplaceDoubleStarPipeError = (error: any)=>
    `[ReplaceDoubleStarPipe] ${JSON.stringify(error)}`;
  constructor(private readonly sanitizer: DomSanitizer,
    private readonly loggerService: LoggerService
  ) {}

  transform(value: any): string {
    try{
    if (value && value.constructor && value.constructor.name === 'SafeHtmlImpl') {
      // Handle SafeHtmlImpl specifically
      const bypassedValue = this.sanitizer.sanitize(SecurityContext.HTML, value) || '';
      const stringValue = bypassedValue.toString(); // Convert SafeHtmlImpl to string
      const transformedValue = stringValue.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
      return transformedValue;
    } else if (typeof value === 'string') {
      // Handle regular string
      const transformedValue = value.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
      return transformedValue;
    } else {
      // Safe error logging with proper null/undefined handling
      const typeName = value === null ? 'Null' : 
                       value === undefined ? 'Undefined' : 
                       (value.constructor && value.constructor.name) || 'Unknown';
      this.loggerService.logError(this.ReplaceDoubleStarPipeError(typeName), "transform");
      return ''; // Handle other cases or log additional information
    }
    
  }
  catch(error: any){
    this.loggerService.logError(this.ReplaceDoubleStarPipeError(error), "transform")
    return '';
  }
  }
}